import { logo } from "../../assets/images";
import "./style.scss"
import dayjs from "dayjs";

const PdfHeader = ({ pdfName,fromDate,toDate,selectedMonth,selectedMonthString, year, minFilter, searchFilter, customBranding }) => {
    return <>
        <div className="pdf-header" >
            <div className="pdf-logo">
                <img src={logo} alt="" />
                {customBranding ? (
                    <div className="heading-details-single">
                        <h1 className="custom-header">{customBranding}</h1>
                    </div>
                ) : (
                    <div className="heading-details">
                        <h1 className="custom-header">MLawyer</h1>
                        <h3 className="custom-header">Smart Legal Intelligence</h3>
                    </div>
                )}
            </div>
            <div className={customBranding ? "pdfName-Details-centered" : "pdfName-Details"}>
                <h4 className="custom-header">{pdfName}</h4>
                {
                    fromDate && toDate?<div>
                    <small style={{padding:0,margin:0}}>Date</small>
                    <p style={{padding:0,margin:0,color:"#fff"}}>{fromDate && toDate ?`${dayjs(fromDate).format("DD-MM-YYYY")} - ${dayjs(toDate).format("DD-MM-YYYY")}`:""}</p>
                </div>:''
                }
                {
                    selectedMonth && <div>
                    <small style={{padding:0,margin:0}}>Month</small>
                    <p style={{padding:0,margin:0,color:"#fff"}}>{dayjs(selectedMonth).format("MMMM YYYY")}</p>
                </div>
                }
                {
                    year && <div>
                    <small style={{padding:0,margin:0}}>Year</small>
                    <p style={{padding:0,margin:0,color:"#fff"}}>{dayjs(year).format("YYYY")}</p>
                </div>
                }
                {
                    minFilter ? <div>
                    <small style={{padding:0,margin:0}}>Minutes</small>
                    <p style={{padding:0,margin:0,color:"#fff"}}>{minFilter} Min</p>
                </div> : ''
                }
                {
                    searchFilter ? <div>
                    <small style={{padding:0,margin:0}}>Search</small>
                    <p style={{padding:0,margin:0,color:"#fff"}}>{searchFilter}</p>
                </div> : ''
                }
            </div>
        </div>
    </>
};
export default PdfHeader